import React from 'react';
import { useSelector } from 'react-redux';
import { selectAllGames, selectGamesLoading } from '@/store/selectors/gamesSelectors';
import GamesStreamlineSection, {
  GamesStreamlineType,
} from '@/components/shared/games/GamesStreamlineSection';
import { BffGamesCategory } from '@lucky7ventures/bff-types';
import GamesSectionHeader from '@/pages/games/lobby/lobby-sections-streamlines/GamesSectionHeader';
import { useIntl } from 'react-intl';
import GamesSection from '@/pages/games/lobby/lobby-sections-streamlines/GamesSection';

const AllGames = () => {
  const games = useSelector(selectAllGames);
  const loading = useSelector(selectGamesLoading);
  const intl = useIntl();

  return (
    <GamesSection>
      <GamesSectionHeader
        title={intl.formatMessage({ id: 'games.categories.allGames' })}
        totalGames={games.length}
        categoryPath="/games/all-games"
      />
      <GamesStreamlineSection
        type={GamesStreamlineType.Double}
        visibleGames={24}
        loading={loading}
        games={games}
        category={BffGamesCategory.AllGames}
      />
    </GamesSection>
  );
};

export default AllGames;
